<template>
  <label
    class="toggle-switch"
    :class="{
      [$class('disabled')]: disabled,
      [$class('loading')]: loading,
    }"
    :for="id"
  >
    <input
      :id="id"
      v-model="localModelValue"
      class="toggle-switch__input visually-hidden"
      :disabled="disabled || loading"
      :name="name"
      type="checkbox"
      @change="updateVModel(localModelValue)"
    >

    <span
      v-if="labelFalse"
      class="toggle-switch__label text-body-m-regular"
      v-html="labelFalse"
    />

    <span
      class="toggle-switch__toggle"
      aria-hidden="true"
    />

    <span
      class="toggle-switch__label text-body-m-regular"
      v-html="labelTrue"
    />
  </label>
</template>

<script>

/**
 * Vue: Toggle switch (toggle-switch)
 * -----------------------------------------------------------------------------
 * Toggle input utility component, represents stylised checkbox.
 *
 * @param {Boolean} [disabled] - Input is disabled.
 * @param {String} id - ID for input.
 * @param {String} [labelFalse] - False/inactive/left side label.
 * @param {String} labelTrue - True/active/right side label.
 * @param {Boolean} [loading] - Loading state.
 * @param {Number|String} modelValue - Current value provided by v-model.
 * @param {String} [name] - Input name.
 *
 * @emits update:model-value - Emit v-model update event.
 *
 */
export default {
  name: 'ToggleSwitch',

  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: '',
      required: true,
    },
    labelFalse: {
      type: String,
      default: '',
    },
    labelTrue: {
      type: String,
      default: '',
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    modelValue: {
      type: Boolean,
      default: false,
      required: true,
    },
    name: {
      type: String,
      default: '',
    },
  },

  emits: {
    'update:model-value': () => true,
  },

  data() {
    return {
      localModelValue: false,
    }
  },

  watch: {

    /**
     * Watch v-model value to update local value.
     */
    modelValue() {
      this.localModelValue = this.modelValue
    },
  },

  mounted() {
    this.localModelValue = this.modelValue
  },

  methods: {

    /**
     * Emit update v-model event.
     * @param {Boolean} value - Updated value.
     */
    updateVModel(value) {
      this.$emit('update:model-value', value)
    },
  },
}
</script>

<style lang="scss">
@import './toggle-switch';
</style>
